var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:['iconLink', { 'iconLink--reversed': _vm.reversed }],attrs:{"to":_vm.to,"href":_vm.href,"target":_vm.target,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),(_vm.icon)?_c('span',{class:`icon-${_vm.icon}`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }